/*协同办公系统*/

/*主容器文件*/
const xtbg_ = () => import("../../../studio/sub_systems/xtbg_system/xtbg_system_main");

/*协同办公系统  首页子系统*/
const xtbg_index_ = () => import("../../../studio/sub_systems/xtbg_system/index_page/index_page_main");
/*协同办公系统  首页子系统 - 工作台*/
const xtbg_index_gzt = () => import("../../../studio/sub_systems/xtbg_system/index_page/gzt/gzt_main");
/*协同办公系统  首页子系统 - 审批列表*/
const xtbg_index_approverFlow = () => import("../../../studio/sub_systems/xtbg_system/index_page/approverFlow/approverFlowList/approverFlowList");
/*协同办公系统  首页子系统 - 通知公告*/
const xtbg_index_tzgg = () => import("../../../studio/sub_systems/xtbg_system/index_page/tzgg/tzgg_main");
/*协同办公系统  首页子系统 - 业务办理 - 待处理*/
const xtbg_index_ywbl_audit = () => import("../../../studio/sub_systems/xtbg_system/index_page/ywbl/audit/audit_main");
/*协同办公系统  首页子系统 - 业务办理 - 已处理*/
const xtbg_index_ywbl_process = () => import("../../../studio/sub_systems/xtbg_system/index_page/ywbl/process/process_main");
/*协同办公系统  首页子系统 - 业务办理 - 我收到的*/
const xtbg_index_ywbl_copy = () => import("../../../studio/sub_systems/xtbg_system/index_page/ywbl/copy/copy_main");
/*协同办公系统  首页子系统 - 业务办理 - 公文管理*/
const xtbg_index_gwgl = () => import("../../../studio/sub_systems/xtbg_system/index_page/gwgl/gwgl_main");

/*协同办公系统  首页子系统 - 业务办理 - 学习中心*/
const xtbg_index_xxzx = () => import("../../../studio/sub_systems/xtbg_system/index_page/zxxx/xxzx/index");
/*知识广场*/
const xtbg_index_zsgc = () => import("../../../studio/sub_systems/xtbg_system/index_page/zxxx/zsgc/index");
/*文档管理*/
const xtbg_index_wdgl = () => import("../../../studio/sub_systems/xtbg_system/index_page/wdgl/index");
/*文件分发管理*/
const xtbg_index_wjffgl = () => import("../../../studio/sub_systems/xtbg_system/index_page/wjgl/wjffgl/index");
/*文件签收查看*/
const xtbg_index_wjqsck = () => import("../../../studio/sub_systems/xtbg_system/index_page/wjgl/wjqsck/index");
/*文件草拟审批*/
const xtbg_index_wjcnsp = () => import("../../../studio/sub_systems/xtbg_system/index_page/wjgl/wjcnsp/index");

export default [
  {
    path: '/xtbgxt',
    name: '协同办公系统',
    redirect: '/xtbgxt/index',
    component: xtbg_,
    children: [
      {
        path: '/xtbgxt/index',
        redirect: '/xtbgxt/index/gzt',
        name: '首页',
        component: xtbg_index_,
        children: [
          {
            path: '/xtbgxt/index/gzt',
            name: '工作台',
            component: xtbg_index_gzt,
          },
          {
            path: '/xtbgxt/index/audit',
            name: '待处理',
            component: xtbg_index_ywbl_audit,
          },
          {
            path: '/xtbgxt/index/process',
            name: '已处理',
            component: xtbg_index_ywbl_process,
          },
          {
            path: '/xtbgxt/index/copy',
            name: '我收到的',
            component: xtbg_index_ywbl_copy,
          },
          {
            path: '/xtbgxt/index/approverFlow',
            name: '审批流程列表',
            component: xtbg_index_approverFlow,
          },
          {
            path: '/xtbgxt/index/tzgg',
            name: '通知公告',
            component: xtbg_index_tzgg,
          },
          {
            path: '/xtbgxt/index/gwgl',
            name: '公文管理',
            component: xtbg_index_gwgl,
          },
          {
            path: '/xtbgxt/index/xxzx',
            name: '学习中心',
            component: xtbg_index_xxzx,
          },
          {
            path: '/xtbgxt/index/zsgc',
            name: '知识广场',
            component: xtbg_index_zsgc,
          },
          {
            path: '/xtbgxt/index/wdgl',
            name: '文档管理',
            component: xtbg_index_wdgl,
          },
          {
            path: '/xtbgxt/index/wjffgl',
            name: '文件分发管理',
            component: xtbg_index_wjffgl,
          },
          {
            path: '/xtbgxt/index/wjqsck',
            name: '文件签收查看',
            component: xtbg_index_wjqsck,
          },
          {
            path: '/xtbgxt/index/wjcnsp',
            name: '文件草拟审批',
            component: xtbg_index_wjcnsp,
          },
        ]
      },

    ]
  },

]



// WEBPACK FOOTER //
// ./src/router/modules/xtbgxt/xtbg_system_page.js